import React, { useEffect } from "react";
import { FormControl, FormControlLabel, Radio, RadioGroup, Stack } from "@mui/material";
import { useActiveIntegrations } from "src/scenes/dashboard/active-integrations-provider";
import Icon from "src/components/icon";
import gitlabIcon from "src/assets/icons/gitlab-int";
import gitlabSelfManagedIcon from "src/assets/icons/gitlab-selfmanaged-int";
import githubIcon from "src/assets/icons/github-int";
import slackIcon from "src/assets/icons/slack-int";
import googleWorkspaceIcon from "src/assets/icons/google-workspace-int";
import microsoftCalendarIcon from "src/assets/icons/microsoft-calendar-int";
import styled from "styled-components";

const ImportantText = styled.span`
    color: ${({ theme }) => theme.palette.primary.main};
    font-size: 14px;
`;

const Text = styled.span`
    font-size: 14px;
    font-weight: 300;
    max-width: 580px;
`;

const CaseAnalysisRadio = ({ value, setValue, isDemo }) => {
    const { activeIntegrations } = useActiveIntegrations();
    useEffect(() => {
        const isGitIntegrated =
            activeIntegrations &&
            activeIntegrations.data &&
            (activeIntegrations.data.integrations.find((int) => int.name === "gitlab")?.connected ||
                activeIntegrations.data.integrations.find((int) => int.name === "gitlabSelfManaged")
                    ?.connected ||
                activeIntegrations.data.integrations.find((int) => int.name === "github")
                    ?.connected);

        const isGitNotIntegrated = !isGitIntegrated;

        const slackIntegrated =
            activeIntegrations &&
            activeIntegrations.data &&
            activeIntegrations.data.integrations.find((int) => int.connected) &&
            activeIntegrations.data.integrations.find((int) => int.name === "slack").connected;

        const slackNotIntegrated = !slackIntegrated;

        const googleIntegrated =
            activeIntegrations &&
            activeIntegrations.data &&
            activeIntegrations.data.integrations.find((int) => int.connected) &&
            activeIntegrations.data.integrations.find((int) => int.name === "google").connected;
        const googleNotIntegrated = !googleIntegrated;

        const microsoftIntegrated =
            activeIntegrations &&
            activeIntegrations.data &&
            activeIntegrations.data.integrations.find((int) => int.connected) &&
            activeIntegrations.data.integrations.find((int) => int.name === "microsoft").connected;
        const microsoftNotIntegrated = !microsoftIntegrated;

        const calendarsNotIntegrated = googleNotIntegrated && microsoftNotIntegrated;

        if (
            activeIntegrations &&
            activeIntegrations.data &&
            activeIntegrations.data.integrations &&
            isGitNotIntegrated &&
            slackNotIntegrated &&
            calendarsNotIntegrated
        ) {
            setValue();
        }
    }, [activeIntegrations && activeIntegrations.data]);

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    const isGitIntegrated =
        activeIntegrations &&
        activeIntegrations.data &&
        (activeIntegrations.data.integrations.find((int) => int.name === "gitlab")?.connected ||
            activeIntegrations.data.integrations.find((int) => int.name === "gitlabSelfManaged")
                ?.connected ||
            activeIntegrations.data.integrations.find((int) => int.name === "github")?.connected);

    const isGitNotIntegrated = !isGitIntegrated;

    const slackIntegrated =
        activeIntegrations &&
        activeIntegrations.data &&
        activeIntegrations.data.integrations.find((int) => int.connected) &&
        activeIntegrations.data.integrations.find((int) => int.name === "slack").connected;

    const slackNotIntegrated = !slackIntegrated;

    const googleIntegrated =
        activeIntegrations &&
        activeIntegrations.data &&
        activeIntegrations.data.integrations.find((int) => int.connected) &&
        activeIntegrations.data.integrations.find((int) => int.name === "google").connected;
    const googleNotIntegrated = !googleIntegrated;

    const microsoftIntegrated =
        activeIntegrations &&
        activeIntegrations.data &&
        activeIntegrations.data.integrations.find((int) => int.connected) &&
        activeIntegrations.data.integrations.find((int) => int.name === "microsoft").connected;
    const microsoftNotIntegrated = !microsoftIntegrated;

    const calendarsNotIntegrated = googleNotIntegrated && microsoftNotIntegrated;
    if (activeIntegrations.status === "PENDING") return null;
    return (
        <FormControl>
            <RadioGroup
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={value}
                onChange={handleChange}
            >
                <FormControlLabel
                    value="mr_duration_to_total"
                    control={<Radio />}
                    style={{ margin: "12px" }}
                    disabled={!isDemo && isGitNotIntegrated}
                    label={
                        isGitNotIntegrated ? (
                            <Stack direction="row" spacing={2} alignItems="center">
                                <Text>
                                    How does the{" "}
                                    <ImportantText>
                                        time it takes for a Pull Request (PR) to be done
                                    </ImportantText>{" "}
                                    correlate with with the number of{" "}
                                    <ImportantText>lines of code of that PR</ImportantText>.
                                </Text>
                                <Icon svg={gitlabIcon} fill="palette.background.inactiveIcons" />
                                <Icon
                                    svg={gitlabSelfManagedIcon}
                                    fill="palette.background.inactiveIcons"
                                />
                                <Icon svg={githubIcon} fill="palette.background.inactiveIcons" />
                            </Stack>
                        ) : (
                            <div style={{ maxWidth: "580px" }}>
                                <Text>
                                    How does the{" "}
                                    <ImportantText>
                                        time it takes for a Pull Request (PR) to be done
                                    </ImportantText>{" "}
                                    correlate with with the number of{" "}
                                    <ImportantText>lines of code of that PR</ImportantText>.
                                </Text>
                            </div>
                        )
                    }
                />
                <FormControlLabel
                    value="review_duration_to_comments"
                    control={<Radio />}
                    style={{ margin: "12px" }}
                    disabled={!isDemo && isGitNotIntegrated}
                    label={
                        isGitNotIntegrated ? (
                            <Stack direction="row" spacing={2} alignItems="center">
                                <Text>
                                    How does the{" "}
                                    <ImportantText>
                                        time it takes for a Pull Request (PR) to be reviewed
                                    </ImportantText>{" "}
                                    correlate with the amount of{" "}
                                    <ImportantText>review comments</ImportantText> it has.
                                </Text>
                                <Icon svg={gitlabIcon} fill="palette.background.inactiveIcons" />
                                <Icon
                                    svg={gitlabSelfManagedIcon}
                                    fill="palette.background.inactiveIcons"
                                />
                                <Icon svg={githubIcon} fill="palette.background.inactiveIcons" />
                            </Stack>
                        ) : (
                            <div style={{ maxWidth: "580px" }}>
                                <Text>
                                    How does the{" "}
                                    <ImportantText>
                                        time it takes for a Pull Request (PR) to be reviewed
                                    </ImportantText>{" "}
                                    correlate with the amount of{" "}
                                    <ImportantText>review comments</ImportantText> it has.
                                </Text>
                            </div>
                        )
                    }
                />
                <FormControlLabel
                    value="meetings_to_chat"
                    control={<Radio />}
                    style={{ margin: "12px" }}
                    disabled={!isDemo && (slackNotIntegrated || calendarsNotIntegrated)}
                    label={
                        slackNotIntegrated || calendarsNotIntegrated ? (
                            <Stack direction="row" spacing={2} alignItems="center">
                                <Text>
                                    How does the{" "}
                                    <ImportantText>time you spent in meetings</ImportantText> in a
                                    day correlate with the{" "}
                                    <ImportantText>time you spent chatting</ImportantText>.
                                </Text>
                                <Icon svg={slackIcon} fill="palette.background.inactiveIcons" />
                                <Icon
                                    svg={googleWorkspaceIcon}
                                    fill="palette.background.inactiveIcons"
                                />
                                <Icon
                                    svg={microsoftCalendarIcon}
                                    fill="palette.background.inactiveIcons"
                                />
                            </Stack>
                        ) : (
                            <div style={{ maxWidth: "580px" }}>
                                <Text>
                                    How does the{" "}
                                    <ImportantText>time you spent in meetings</ImportantText> in a
                                    day correlate with the{" "}
                                    <ImportantText>time you spent chatting</ImportantText>.
                                </Text>
                            </div>
                        )
                    }
                />
                <FormControlLabel
                    value="comms_to_lines"
                    control={<Radio />}
                    style={{ margin: "12px" }}
                    disabled={
                        !isDemo &&
                        (isGitNotIntegrated || (slackNotIntegrated && calendarsNotIntegrated))
                    }
                    label={
                        isGitNotIntegrated || (slackNotIntegrated && calendarsNotIntegrated) ? (
                            <Stack direction="row" spacing={2} alignItems="center">
                                <Text>
                                    How does the{" "}
                                    <ImportantText>time you spent in communications</ImportantText>{" "}
                                    (meetings and chats) in a day correlate with the{" "}
                                    <ImportantText>amount of code</ImportantText> you manage to
                                    commit on the same day.
                                </Text>
                                <Icon svg={gitlabIcon} fill="palette.background.inactiveIcons" />
                                <Icon
                                    svg={gitlabSelfManagedIcon}
                                    fill="palette.background.inactiveIcons"
                                />
                                <Icon svg={githubIcon} fill="palette.background.inactiveIcons" />
                                <Icon svg={slackIcon} fill="palette.background.inactiveIcons" />
                                <Icon
                                    svg={googleWorkspaceIcon}
                                    fill="palette.background.inactiveIcons"
                                />
                                <Icon
                                    svg={microsoftCalendarIcon}
                                    fill="palette.background.inactiveIcons"
                                />
                            </Stack>
                        ) : (
                            <div style={{ maxWidth: "580px" }}>
                                <Text>
                                    How does the{" "}
                                    <ImportantText>time you spent in communications</ImportantText>{" "}
                                    (meetings and chats) in a day correlate with the{" "}
                                    <ImportantText>amount of code</ImportantText> you manage to
                                    commit on the same day.
                                </Text>
                            </div>
                        )
                    }
                />
                <FormControlLabel
                    value="meetings_to_lines"
                    control={<Radio />}
                    style={{ margin: "12px" }}
                    disabled={!isDemo && (isGitNotIntegrated || calendarsNotIntegrated)}
                    label={
                        isGitNotIntegrated || calendarsNotIntegrated ? (
                            <Stack direction="row" spacing={2} alignItems="center">
                                <Text>
                                    How does the{" "}
                                    <ImportantText>time you spent in meetings</ImportantText> in a
                                    day correlate with the{" "}
                                    <ImportantText>amount of code</ImportantText> you manage to
                                    commit on the same day.
                                </Text>
                                <Icon svg={gitlabIcon} fill="palette.background.inactiveIcons" />
                                <Icon
                                    svg={gitlabSelfManagedIcon}
                                    fill="palette.background.inactiveIcons"
                                />
                                <Icon svg={githubIcon} fill="palette.background.inactiveIcons" />
                                <Icon
                                    svg={googleWorkspaceIcon}
                                    fill="palette.background.inactiveIcons"
                                />
                                <Icon
                                    svg={microsoftCalendarIcon}
                                    fill="palette.background.inactiveIcons"
                                />
                            </Stack>
                        ) : (
                            <div style={{ maxWidth: "580px" }}>
                                <Text>
                                    How does the{" "}
                                    <ImportantText>time you spent in meetings</ImportantText> in a
                                    day correlate with the{" "}
                                    <ImportantText>amount of code</ImportantText> you manage to
                                    commit on the same day.
                                </Text>
                            </div>
                        )
                    }
                />
            </RadioGroup>
        </FormControl>
    );
};
export default CaseAnalysisRadio;
